import React, { useState, useEffect, useRef } from 'react'
import { Input } from 'semantic-ui-react'
import PropTypes from 'prop-types'


const CurrencyInput = ({ value, onChange, currency: initCurrency, min, max, digits,  ...rest }) => {
    const format = (val) => {
        return parseFloat(val || 0).toFixed(digits || 2)
    }
    const [displayValue, setDisplayValue] = useState(format(value || 0))
    const [disabled, setDisabled] = useState(false)
    const [currency, setCurrency] = useState(initCurrency)
    const ref = useRef()

    useEffect(() => {
        if (ref.current && ref.current.inputRef.current !== document.activeElement) {
            let displayVal = value === null ? '' : format(validateMinMax(value));
            setDisplayValue(displayVal)
        }
        setDisabled(value === null)
    }, [value])

    useEffect(() => {
        setCurrency(initCurrency)
    }, [initCurrency]);
    
    const handleChange = (e, { value: inputValue }) => {
        setDisplayValue(inputValue)
        if (onChange) {
            onChange(parseFloat(format(inputValue)))
        }
    }

    const onBlur = () => {
        setDisplayValue(format(validateMinMax(value || displayValue)))
    }

    const validateMinMax = inputValue => {
        let parsedInputValue = parseFloat(inputValue || 0);
        if (min !== null && min !== undefined && parsedInputValue < min) parsedInputValue = min;
        if (max !== null && max !== undefined && parsedInputValue > max) parsedInputValue = max;
        return parsedInputValue;
    }

    return <Input ref={ref} disabled={disabled} value={displayValue} onChange={handleChange} labelPosition="right" label={currency ? currency : null} onBlur={onBlur} {...rest} />
}
CurrencyInput.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    currency: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    digits: PropTypes.number
}

export default CurrencyInput